/**
 * Generic account interface that can be implemented by different authentication providers
 * This allows MSAL, Auth0, and other providers to have their own account implementations
 * while maintaining compatibility with the common authentication flow
 */
export interface IAccount {
    /** Username (typically email or principal name) */
    userName: string;
    
    /** Display name of the user */
    name: string;
}

/**
 * Base Account class that implements IAccount interface
 * Can be extended by provider-specific account classes
 */
export abstract class BaseAccount implements IAccount {
    userName: string;
    name: string;

    constructor(userName: string, name: string) {
        this.userName = userName;
        this.name = name;
    }
}